// imove-behavior: 登录成功获取当前用户权限

export default async function(ctx) {
  ctx.emit('checkLoginSuccess');
}